export default __webpack_public_path__ + "static/media/kitchen4-afterA-1440w.fd79f2ef.webp";